// extracted by mini-css-extract-plugin
export default {"container":"addPermissionGroup_container__KZNbo","errorMessage":"addPermissionGroup_errorMessage__eVL+U"};